import Vue from 'vue';
import { Pagination, Icon, List, Comment, Tooltip } from 'ant-design-vue';
Vue.use(Pagination);
Vue.use(Icon);
Vue.use(List);
Vue.use(Comment);
Vue.use(Tooltip)

// avatar,textarea,FormItem,button
